import Api from "./Api.ts";

export const login = async (username: string, password: string) => {
    const response = await Api.post('/super-admin/login', { username, password }); 
    return response.data; 
};
